module.exports = __webpack_public_path__ + "img/L_316_326.2c72f865.png";